import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Modal from '../../Modal/Modal';

import StepByStep from '../../StepByStep';
import LegacyOrderDetails from './LegacyOrderDetails';

const steps = [LegacyOrderDetails];

const LegacyOrderDetailsModal = ({ isOpen, handleClose, legacyOrder }) => {
  const { t } = useTranslation();
  const [error, setError] = useState('');

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        close={handleClose}
        title={t('account.legacyOrderDetails.orderDetails')}
        size="sm"
        closeIconVisible
      >
        <StepByStep saveStepDisabled>
          {({ goStepBack }) =>
            steps.map((step) =>
              React.createElement(step, {
                handleBack: goStepBack,
                handleClose,
                setError,
                hasError: !!error,
                onButtonClick: handleClose,
                legacyOrder,
              }),
            )
          }
        </StepByStep>
      </Modal>
    </>
  );
};

LegacyOrderDetailsModal.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  legacyOrder: PropTypes.shape({}),
};

export default LegacyOrderDetailsModal;
